const Accordion = (domEl) => {
	// Elements
	const heading = domEl.querySelector('.acf-block-accordion-heading');
	const content = domEl.querySelector('.acf-block-accordion-content');

	// State
	let isOpen = false;

	// Methods
	const open = () => {
		isOpen = true;
		domEl.classList.add('is-open');
		heading.setAttribute('aria-expanded', 'true');
		content.style.display = 'block';
		// Use setTimeout to ensure display: block is applied before animation
		setTimeout(() => {
			content.style.height = content.scrollHeight + 'px';
		}, 1);
	};

	const close = () => {
		isOpen = false;
		domEl.classList.remove('is-open');
		heading.setAttribute('aria-expanded', 'false');
		content.style.height = '0';
		// Wait for animation to complete before setting display none
		content.addEventListener('transitionend', () => {
			if(!isOpen) { // Check the state again in case it was reopened during animation
				content.style.display = 'none';
			}
		}, { once: true });
	};

	const toggle = () => {
		if(isOpen) {
			close();
		}
		else {
			open();

			// Close adjacent accordions
			/*
			let sibling = domEl;

			// Close previous adjacent accordions
			while(sibling.previousElementSibling &&
			sibling.previousElementSibling.matches('.acf-block-accordion') &&
			!sibling.previousElementSibling.matches('p, div:not(.acf-block-accordion)')) {
				const accordionHead = sibling.previousElementSibling.querySelector('.acf-block-accordion-heading');
				if(sibling.previousElementSibling.classList.contains('is-open')) {
					accordionHead.click();
				}
				sibling = sibling.previousElementSibling;
			}

			// Close next adjacent accordions
			sibling = domEl;
			while(sibling.nextElementSibling &&
			sibling.nextElementSibling.matches('.acf-block-accordion') &&
			!sibling.nextElementSibling.matches('p, div:not(.acf-block-accordion)')) {
				const accordionHead = sibling.nextElementSibling.querySelector('.acf-block-accordion-heading');
				if(sibling.nextElementSibling.classList.contains('is-open')) {
					accordionHead.click();
				}
				sibling = sibling.nextElementSibling;
			}
			*/
		}
	};

	// Handle keydown
	const handleKeydown = (event) => {
		if(event.key === 'Enter') {
			event.preventDefault();
			toggle();
		}
	};

	// Update height on resize if accordion is open
	let updateHeightTimeout;
	const updateHeight = () => {
		if(isOpen) {
			// Temporarily remove transition and height to get true scrollHeight
			const currentTransition = content.style.transition;
			const currentHeight = content.style.height;
			content.style.transition = 'none';
			content.style.height = 'auto';

			// Get the new scrollHeight
			const newHeight = content.scrollHeight;

			// Reset to previous height without transition
			content.style.height = currentHeight;

			// Force reflow
			content.offsetHeight;

			// Set new height and restore transition
			content.style.transition = currentTransition;
			content.style.height = newHeight + 'px';

			updateHeightTimeout = setTimeout(updateHeight, 500);
		}
		else {
			if(updateHeightTimeout) {
				clearTimeout(updateHeightTimeout);
			}
		}
	};

	// Handle WPForms submission event
	const updateAfterFormSubmit = () => {
		if(isOpen) {
			// Force a recalculation of the content height
			content.style.height = 'auto';
			const newHeight = content.scrollHeight;
			content.style.height = newHeight + 'px';
		}
	};
	const setupFormListener = () => {
		// Look for WPForms within this accordion
		const wpform = content.querySelector('.wpforms-form');

		if(wpform) {
			// Listen for the WPForms submit success event
			document.addEventListener('wpformsAjaxSubmitSuccess', (e) => {
				// Check if the event is from a form within this accordion
				if(content.contains(e.detail.container)) {
					// Short delay to allow DOM to update with any success messages
					setTimeout(updateAfterFormSubmit, 100);

					if(updateHeightTimeout) {
						clearTimeout(updateHeightTimeout);
					}
				}
			});

			// Also handle the case where form validation messages appear
			document.addEventListener('wpformsAjaxSubmitFailed', (e) => {
				if(content.contains(e.detail.container)) {
					setTimeout(updateAfterFormSubmit, 100);
				}
			});

			// Continuously update the height - in case we submit with errors and change the height
			wpform.addEventListener('submit', () => {
				if(updateHeightTimeout) {
					clearTimeout(updateHeightTimeout);
				}
				updateHeightTimeout = setTimeout(updateHeight, 500);
			})

		}
	};


	// Initialize
	const init = () => {
		// Set up ARIA attributes
		const headingId = `accordion-heading-${Math.random().toString(36).substring(2, 9)}`;
		const contentId = `accordion-content-${Math.random().toString(36).substring(2, 9)}`;

		heading.id = headingId;
		content.id = contentId;

		heading.setAttribute('aria-expanded', 'false');
		heading.setAttribute('aria-controls', contentId);
		content.setAttribute('aria-labelledby', headingId);

		// Set initial styles for animation
		content.style.height = '0';
		content.style.overflow = 'hidden';
		content.style.transition = 'height 0.3s ease-out';

		// Add click handler
		heading.addEventListener('click', toggle);

		// Add keyboard handler
		heading.addEventListener('keydown', handleKeydown);

		// Add the WPForms listener setup
		setupFormListener();

		// Add resize handler with debouncing
		let resizeTimeout;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(updateHeight, 1);
		});
	};

	init();

	return {
		open,
		close,
		toggle
	};
};

export default Accordion;